import { render } from "./CreateBoard.html?vue&type=template&id=4795d536&external"
import script from "./CreateBoard.js?vue&type=script&lang=js&external"
export * from "./CreateBoard.js?vue&type=script&lang=js&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__